import type { HrEmployee } from '../employee/hr-employee.models';

export interface HrSelfServiceProfile {
  owningCompanyId?: number;
  customerId?: number;
  employeeId?: number;
  profile?: HrEmployee;
}

export interface HrNotificationPreference {
  notificationPreferenceId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  customerId?: number;
  channel?: string;
  topicCode?: string;
  enabled?: boolean;
  deliveryAddress?: string;
  quietStartTime?: string;
  quietEndTime?: string;
  locale?: string;
  timezone?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrManagerTeamSummary {
  owningCompanyId?: number;
  managerEmployeeId?: number;
  managerName?: string;
  teamSize?: number;
  pendingLeaveRequests?: number;
  submittedTimesheets?: number;
  openLearningAssignments?: number;
  directReports?: HrEmployee[];
}

export interface HrManagerApprovalItem {
  approvalType?: string;
  sourceId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeName?: string;
  employeeNumber?: string;
  status?: string;
  title?: string;
  summary?: string;
  requestedAt?: string;
}

export const HR_NOTIFICATION_CHANNELS = ['EMAIL', 'IN_APP', 'SMS', 'WHATSAPP'];

export const HR_NOTIFICATION_TOPICS = ['HR_GENERAL', 'DOCUMENT_EXPIRY', 'LEAVE_UPDATES', 'TIMESHEET_UPDATES', 'PAYSLIP_PUBLISHED', 'LEARNING_DUE', 'READINESS_WARNING'];

